<template>
  <NuxtLoadingIndicator color="#E5432F" :height="3" />
  <Transition name="overlay">
    <div v-if="navigating" class="page-overlay" />
  </Transition>
  <NuxtPage />
</template>
<script setup lang="ts">
import '@stripe/stripe-js'
import { useStore } from '~/stores/useStore'

const route = useRoute()
const nuxtApp = useNuxtApp()
const navigating = ref(false)

useHead({
  title: 'Helping developers with quality engineering in the A.I. era',
  link: [
    {
      rel: 'canonical',
      href: `https://filiphric.com${route.path}`
    }
  ]
})

const store = useStore()

let navToken = 0

nuxtApp.hook('page:start', () => {
  navToken++
  navigating.value = true
})

nuxtApp.hook('page:finish', () => {
  const tokenAtFinish = navToken
  // Wait for the browser to paint the new page before removing the overlay
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (tokenAtFinish === navToken) {
        navigating.value = false
      }
    })
  })
})

// Load user data on app initialization
onMounted(async () => {
  await store.loadUser()
})

</script>
<style scoped>
.page-overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: var(--page-surface);
}

/* Appear instantly */
.overlay-enter-active {
  transition: none;
}

/* Fade out smoothly */
.overlay-leave-active {
  transition: opacity 0.15s ease-out;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}
</style>
